<template>
  <el-row :gutter="40" class="panel-group">
    <svg-sprite />
    <el-col :xs="12" :sm="12" :lg="{span: '4-8'}" class="card-panel-col">
      <div class="card-panel" @click="handleSetLineChartData('newVisitis')">
        <div class="card-panel-icon-wrapper icon-money ">
          <svg-icon icon="color" class="card-panel-icon"/>
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            匿名用户数
          </div>
          <count-to :start-val="0" :end-val="countData.AnonymousNum" :duration="2600" class="card-panel-num" />
        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="{span: '4-8'}" class="card-panel-col">
      <div class="card-panel" @click="handleSetLineChartData('messages')">
        <div class="card-panel-icon-wrapper icon-people ">
          <svg-icon icon="color" class="card-panel-icon"/>
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            消息数
          </div>
          <count-to :start-val="0" :end-val="countData.MessageNum" :duration="3000" class="card-panel-num" />
        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="{span: '4-8'}" class="card-panel-col">
      <div class="card-panel" @click="handleSetLineChartData('purchases')">
        <div class="card-panel-icon-wrapper icon-message">
          <svg-icon icon="color" class="card-panel-icon"/>
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            在线总数
          </div>
          <count-to :start-val="0" :end-val="countData.TotalNum" :duration="3200" class="card-panel-num" />
        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="{span: '4-8'}" class="card-panel-col">
      <div class="card-panel" @click="handleSetLineChartData('shoppings')">
        <div class="card-panel-icon-wrapper icon-money">
          <svg-icon icon="color" class="card-panel-icon"/>
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            登录用户数
          </div>
          <count-to :start-val="0" :end-val="countData.UserNum" :duration="3600" class="card-panel-num" />
        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="{span: '4-8'}" class="card-panel-col">
      <div class="card-panel" @click="handleSetLineChartData('shoppings')">
        <div class="card-panel-icon-wrapper icon-message">
          <svg-icon icon="color" class="card-panel-icon"/>
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">
            客服在线数
          </div>
          <count-to :start-val="0" :end-val="countData.KfNum" :duration="3600" class="card-panel-num" />
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
  import SvgIcon from '../common/SvgIcon.vue'
  import SvgSprite from '../common/SvgSprite.vue'

import CountTo from 'vue-count-to'

export default {
    props: {
      countData: {
        type: Object
      }
    },
  components: {
    CountTo,
    SvgIcon,
    SvgSprite
  },
  methods: {
    handleSetLineChartData(type) {
      this.$emit('handleSetLineChartData', type)
    }
  }
}
</script>

<style scoped>
  .panel-group {
    margin-top: 18px;
  }
  .panel-group .card-panel-col {
    margin-bottom: 32px;
  }
  .panel-group .card-panel {
    height: 108px;
    cursor: pointer;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.05);
    border-color: rgba(0, 0, 0, 0.05);
  }
  .panel-group .card-panel:hover .card-panel-icon-wrapper {
    color: #fff;
  }
  .panel-group .card-panel:hover .icon-people {
    background: #40c9c6;
  }
  .panel-group .card-panel:hover .icon-message {
    background: #36a3f7;
  }
  .panel-group .card-panel:hover .icon-money {
    background: #f4516c;
  }
  .panel-group .card-panel:hover .icon-shopping {
    background: #34bfa3;
  }
  .panel-group .card-panel .icon-people {
    color: #40c9c6;
  }
  .panel-group .card-panel .icon-message {
    color: #36a3f7;
  }
  .panel-group .card-panel .icon-money {
    color: #f4516c;
  }
  .panel-group .card-panel .icon-shopping {
    color: #34bfa3;
  }
  .panel-group .card-panel .card-panel-icon-wrapper {
    float: left;
    margin: 14px 0 0 14px;
    padding: 16px;
    transition: all 0.38s ease-out;
    border-radius: 6px;
  }
  .panel-group .card-panel .card-panel-icon {
    float: left;
    font-size: 48px;
  }
  .panel-group .card-panel .card-panel-description {
    float: right;
    font-weight: bold;
    margin: 26px;
    margin-left: 0;
  }
  .panel-group .card-panel .card-panel-description .card-panel-text {
    line-height: 18px;
    color: rgba(0, 0, 0, 0.45);
    font-size: 16px;
    margin-bottom: 12px;
  }
  .panel-group .card-panel .card-panel-description .card-panel-num {
    font-size: 20px;
  }

  @media (max-width: 550px) {
    .card-panel-description {
      display: none;
    }

    .card-panel-icon-wrapper {
      float: none !important;
      width: 100%;
      height: 100%;
      margin: 0 !important;
    }
    .card-panel-icon-wrapper .svg-icon {
      display: block;
      margin: 14px auto !important;
      float: none !important;
    }
  }

  .panel-msg {
    width: 48px;
    height: 48px;
  }
  .panel-msg:hover {

    fill: #2B76B3;
  }

  .el-col-lg-4-8 {
    width: 20%;
  }
</style>
